module.exports = __webpack_public_path__ + "static/media/awaken-amazing.bd5a5b74.png";